import React from 'react';
import * as PropTypes from 'prop-types';

export const CurrentThumbnail = ({ newThumbId, videoThumbnailUrl }) => {
  if (!newThumbId) {
    return videoThumbnailUrl ? (
      <img src={videoThumbnailUrl} alt="Current Thumbnail" data-e2e="current-thumbnail" />
    ) : (
      <img
        src={`${window.__MOVINGIMAGE_CT_PUBLIC_URL}/static/img/thumbnail-not-found.png`}
        alt="Current Thumbnail Missing"
        data-e2e="current-thumbnail"
      />
    );
  }
  return null;
};

CurrentThumbnail.propTypes = {
  newThumbId: PropTypes.number,
  videoThumbnailUrl: PropTypes.string,
};
